(function (app) {
    var annualPlanning = {
        Year: 2017
    };

    app.provider("planningKitApi", [function () {
        this.$get = ["$q", "portalApiGateway", function($q, portalApiGateway) {
            var service = {};

            service.getAnnualPlanningKit = function () {
                return portalApiGateway.get("/PlanningKits/AnnualPlanningKit");
            };

            service.getOnboardingKit = function () {
                return portalApiGateway.get("/PlanningKits/OnboardingKit");
            };

            service.hasSubmittedOnboardingKit = function () {
                return portalApiGateway.get("/PlanningKits/OnboardingKit/Submitted");
            };

            service.hasSubmittedAnnualPlanningKit = function () {
                return portalApiGateway.get("/PlanningKits/AnnualPlanningKit/Submitted");
            };

            service.saveOnboardingKit = function (form) {
                return portalApiGateway.post("/PlanningKits/OnboardingKit", form);
            };

            service.submitOnboardingKit = function (form) {
                return portalApiGateway.post("/PlanningKits/OnboardingKit/Submit", form);
            };

            service.saveAnnualPlanningKit = function (form) {
                return portalApiGateway.post("/PlanningKits/AnnualPlanningKit", form);
            };

            service.submitAnnualPlanningKit = function (form) {
                return portalApiGateway.post("/PlanningKits/AnnualPlanningKit/Submit", form);
            };

            return service;
        }];
    }]);
})(window.app); // jshint ignore:line